import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { Button, IconBell } from '@machobear/design-system'

import { breakpoints } from '@/styles'

import makeAlertButton from './alert-button-base'

const CreateAlertWrapper = styled.div`
  ${props =>
    props.hideOnMobile &&
    `
    @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
      display: none;
    }
  `}
`

const AlertButtonList = makeAlertButton(({ hideOnMobile = true, ...rest }) => {
  const { t } = useTranslation()
  return (
    <CreateAlertWrapper hideOnMobile={hideOnMobile}>
      <Button
        {...rest}
        variant="ghost"
        id="create-alert-main-click"
        icon={<IconBell />}
      >
        {t('filters:b.listing.alert.create.button', 'Create Alert')}
      </Button>
    </CreateAlertWrapper>
  )
}, 'AlertButtonList')

export default AlertButtonList
